import { useLang } from "@/lib/i18n";
import { useReveal } from "@/lib/useReveal";

export const Process = () => {
  const { t } = useLang();
  const { ref, visible } = useReveal();
  return (
    <section
      id="process"
      data-testid="process-section"
      ref={ref}
      className={`py-20 md:py-32 reveal-up ${visible ? "in-view" : ""}`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-12 mb-16 md:mb-20 items-end">
          <div className="col-span-12 lg:col-span-5">
            <div className="overline mb-6">{t.process.overline}</div>
            <h2 className="editorial-h text-4xl md:text-5xl lg:text-6xl whitespace-pre-line">
              {t.process.title}
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:col-start-7">
            <img
              src="https://images.pexels.com/photos/30166261/pexels-photo-30166261.jpeg"
              alt="Girona"
              loading="lazy"
              className="w-full aspect-[16/10] object-cover"
            />
            <div className="overline mt-4">El riu Onyar — Girona</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-300">
          {t.process.steps.map((s, i) => (
            <div
              key={i}
              data-testid={`process-step-${i}`}
              className="bg-[#fafafa] p-8 md:p-10 min-h-[280px] flex flex-col"
            >
              <div className="font-mono text-xs text-neutral-500 mb-8">
                {s.n}
              </div>
              <h3 className="font-serif text-3xl md:text-4xl tracking-tight mb-5">
                {s.name}
              </h3>
              <p className="text-sm md:text-[15px] leading-relaxed text-neutral-600 mt-auto">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
